import { ApiService } from "./AbstractApiService";
import {
  IForm,
  IFormUser,
  IFormDataModel,
  IFormSections,
  IFormCategoryModels,
  IFormEmailRouting,
  IFormUserEmailRouting,
  IFormRoleEmailRouting,
} from "@/interfaces/iForm";
import { IUserFormCreate } from "@/interfaces/iUser";
import {
  IEventManagementFormModel,
  IEventManagements,
} from "@/interfaces/iEventManagement";
import qs from "qs";
import { IPageModel } from "@/interfaces/iPageModel";
import API from "./handlers/base.service";
// import { IForms } from "@/interfaces/iSite";
import moment from "moment";
export class FormApi extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: FormApi | null;
  constructor() {
    super("forms");
  }
  // Start: Wakkar's Code
  public async getAllSections() {
    return this.get("sections", {}).then((response) => response.data);
  }
  // ADD Form
  public async addForm(payload?: any, edit?: boolean) {
    if (edit) {
      return this.put("definitions/global/" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("definitions/global", payload).then(
        (response) => response.data
      );
    }
  }
  // End: Wakkar's Code
  public async updateFormSections(
    payload: any
  ): Promise<IPageModel<IFormSections>> {
    return this.post(`definitionSections`, payload).then(
      (response) => response.data
    );
  }
  public async updateFormSectionLocation(
    webId,
    payload: any
  ): Promise<IPageModel<IFormSections>> {
    return this.put(`definitionSections/${webId}`, payload).then(
      (response) => response.data
    );
  }
  public async addFormUser(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<IFormUser>> {
    if (edit) {
      return this.put("formUsers" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("formUsers", payload).then((response) => response.data);
    }
  }

  public async getFormUserList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IFormUser>> {
    return this.get(`formUsers`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async getFormList(
    queryParams?: Record<string, string | number>
  ): Promise<IPageModel<IForm>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get("definitions", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async getSectionList(
    queryParams?: Record<string, string | number>
  ): Promise<IPageModel<IFormSections>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get("sections", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getForm(id: number): Promise<IPageModel<IForm>> {
    return this.get(`definitions/${id}`).then((response) => response.data);
  }

  public async getFormById(id: number): Promise<IForm> {
    return this.get(`definitions/${id}`).then((response) => response.data);
  }

  public transformDateRangeParams(
    params: Record<string, string | number>
  ): Record<string, string | number> {
    if (
      params &&
      params["startDate"] &&
      `${params["startDate"]}`.split(",").length > 1
    ) {
      const dates = `${params["startDate"]}`.split(",");
      params["startDate"] = moment(dates[0]).format("YYYY-MM-DDTHH:mm:ss[Z]");

      const endDate = new Date(dates[1]);
      endDate.setHours(23, 59, 59);

      // Format the end date as a string without converting to UTC
      const endDateString = `${endDate.getFullYear()}-${String(
        endDate.getMonth() + 1
      ).padStart(2, "0")}-${String(endDate.getDate()).padStart(
        2,
        "0"
      )}T${String(endDate.getHours()).padStart(2, "0")}:${String(
        endDate.getMinutes()
      ).padStart(2, "0")}:${String(endDate.getSeconds()).padStart(2, "0")}Z`;

      params["endDate"] = endDateString;
    }

    const { ...rest } = params;
    return rest;
  }

  public async deleteSiteForms(
    id: number,
    payload: any
  ): Promise<IPageModel<IForm>> {
    return this.service
      .delete(`site/siteForms/${id}/site`, { data: payload })
      .then((response) => response.data);
  }

  public async deleteFormSections(payload: any): Promise<IPageModel<IForm>> {
    return this.service
      .delete(`/forms/definitionSections`, { data: payload })
      .then((response) => response.data);
  }

  public async sortFormSectionSequence(id: number, payload: any): Promise<any> {
    return this.service
      .put(`/forms/definitionSections/${id}/sequence`, payload)
      .then((response) => response.data);
  }

  public async deleteCategories(
    id: number,
    payload: any
  ): Promise<IPageModel<IFormCategoryModels>> {
    return this.service
      .delete(`forms/categories/` + payload, { data: payload })
      .then((response) => response.data);
  }

  public async deleteEmailRouting(
    id: number,
    payload: any
  ): Promise<IPageModel<IFormEmailRouting>> {
    return this.service
      .delete(`forms/routings/` + payload, { data: payload })
      .then((response) => response.data);
  }

  public async deleteUserEmailRouting(
    id: number,
    payload: any
  ): Promise<IPageModel<IFormUserEmailRouting>> {
    return this.service
      .delete(`forms/userRoutings/` + payload, { data: payload })
      .then((response) => response.data);
  }
  public async deleteRoleEmailRouting(
    id: number,
    payload: any
  ): Promise<IPageModel<IFormRoleEmailRouting>> {
    return this.service
      .delete(`forms/roleRoutings/` + payload, { data: payload })
      .then((response) => response.data);
  }
  public bulkDeleteEntity(entity: string, params: string[]) {
    return this.service
      .delete(`${entity}`, { data: params })
      .then((response) => response.data);
  }
  public async getFormSectionList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IFormDataModel>> {
    return this.get(`definitionSections`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async getFormUsers(
    id,
    params?: Record<string, string | number>
  ): Promise<IPageModel<any>> {
    return this.get(`formUsers/info?formDefinitionId=${id}`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async getFormUser(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IFormUser>> {
    return API.get("forms/formUsers/assignment", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async submitCloneForm(data): Promise<any> {
    return this.post("definitions/global", data).then(
      (response) => response.data
    );
  }

  public async addFormUsers(payload: any) {
    return API.post("forms/formUsers/multiple", payload).then(
      (response) => response.data
    );
  }

  public async getFormSitesList(
    id: number,
    queryParams?: Record<string, string | number>
  ): Promise<IPageModel<IForm>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get(`siteForms/${id}/sites`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async addFormCategories(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<IFormCategoryModels>> {
    if (edit) {
      return this.put("categories/" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("categories", payload).then((response) => response.data);
    }
  }
  public async getFormCategoryList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IFormCategoryModels>> {
    return this.service
      .get(`categories`, {
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
      })
      .then((response) => response.data);
  }
  public async getCategoriesList() {
    return this.service
      .get(
        `static-data/filter/LOOKUP_FILTER/filters?filter[lookupName]=LKFormsCategory`
      )
      .then((response) => response.data);
  }
  public async addFormEmailRouting(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<IFormEmailRouting>> {
    if (edit) {
      return this.put("routings/" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("routings", payload).then((response) => response.data);
    }
  }

  public async addSections(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<IFormSections>> {
    if (edit) {
      return this.put("sections/" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("sections", payload).then((response) => response.data);
    }
  }

  public async getFormEmailRoutingList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IFormEmailRouting>> {
    return this.get(`routings`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async addFormUserEmailRouting(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<IFormUserEmailRouting>> {
    if (edit) {
      return this.put("userRoutings/" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("userRoutings", payload).then(
        (response) => response.data
      );
    }
  }
  public async getFormUserEmailRoutingList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IFormUserEmailRouting>> {
    return this.get(`userRoutings`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async addFormRoleEmailRouting(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<IFormEmailRouting>> {
    if (edit) {
      return this.put("roleRoutings/" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("roleRoutings", payload).then(
        (response) => response.data
      );
    }
  }
  public async getFormRoleEmailRoutingList(
    params?: Record<string, string | number>
  ): Promise<IPageModel<IFormRoleEmailRouting>> {
    return this.get(`roleRoutings`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async getFormEventList(
    id: number,
    params?: Record<string, string | number>
  ): Promise<IPageModel<IEventManagements>> {
    return this.service
      .get(`notification/eventForms/${id}/events`, {
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
      })
      .then((response) => response.data);
  }

  public async deleteFormEvent(
    id: number,
    payload: any
  ): Promise<IPageModel<IEventManagementFormModel>> {
    return this.service
      .delete(`notification/eventForms/${id}/events`, {
        data: payload,
      })
      .then((response) => response.data);
  }

  public async deleteFormEventBulk(
    id: number,
    payload: any
  ): Promise<IPageModel<IEventManagementFormModel>> {
    return this.service
      .delete(`notification/eventForms/${id}/events`, {
        data: payload,
      })
      .then((response) => response.data);
  }

  public async deleteNote(id: number): Promise<any> {
    return API.delete(`document/notes/${id}`).then((response) => response.data);
  }

  public async deleteDocument(id: number): Promise<any> {
    return API.delete(`document/${id}`).then((response) => response.data);
  }
  public async addFormEvent(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<IEventManagements>> {
    if (edit) {
      return this.service
        .put(`notification/eventForms/` + payload?.webId, payload)
        .then((response) => response.data);
    } else {
      return this.service
        .post(`notification/eventForms`, payload)
        .then((response) => response.data);
    }
  }
}

export async function getForm<T extends string>(
  url: string
): Promise<Array<Record<any, any>>> {
  return API.get(url).then((res) => {
    return res.data;
  });
}

export function convertFormToFilters<T extends string>(
  lookups: Array<Record<any, any>>,
  key: string,
  value: string
) {
  const filters = lookups?.map((item) => {
    return {
      label: item[key],
      value: item[value],
    };
  });
  return filters;
}

export async function getFormFilters(url: string, key: string, value: string) {
  const forms = await getForm(url);
  return convertFormToFilters(forms, key, value);
}
export async function getMethod<T extends string>(
  url: string
): Promise<Array<Record<any, any>>> {
  return API.get(url).then((res) => {
    return res.data;
  });
}
